import React from 'react'
import { StyleSheet } from 'react-native'
import { DS } from '@/design-system'

interface InfoRowProps {
  label: string
  value: string
}

export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <DS.Frame row justifyContent="space-between" alignItems="center" style={styles.row}>
      <DS.Text variant="Body Medium/Regular" style={styles.label}>
        {label}
      </DS.Text>
      <DS.Text variant="Body Medium/Medium" style={styles.value}>
        {value}
      </DS.Text>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  row: {
    paddingVertical: 2
  },
  label: {
    color: DS.palette['Global/Black']
  },
  value: {
    color: DS.palette['Global/Black']
  }
})
